import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { NovaOrb } from "../components/NovaOrb";
import { useAuth } from "../context/AuthContext";
import { api } from "../lib/api";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (!res.ok) {
      setError(res.error);
      return;
    }
    try {
      const { data } = await api.get("/onboarding/status");
      navigate(data.onboarding_complete ? "/app/plan" : "/onboarding");
    } catch {
      navigate("/onboarding");
    }
  };

  return (
    <div className="min-h-screen bg-kaizen-bg flex flex-col items-center justify-center px-6 relative overflow-hidden">
      <div className="absolute inset-0 -z-10 bg-[radial-gradient(circle_at_50%_0%,rgba(139,93,199,0.16),transparent_60%)]" />
      <Link to="/" className="mb-6">
        <NovaOrb size={80} />
      </Link>
      <h1 className="font-display text-3xl text-kaizen-text mb-8">Welcome back</h1>

      <form onSubmit={handleSubmit} className="glass-card w-full max-w-sm rounded-3xl p-7 space-y-4" data-testid="login-form">
        <div>
          <label className="text-xs text-kaizen-dim tracking-wide">Email</label>
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            data-testid="login-email-input"
            className="mt-1.5 w-full bg-white/[0.04] border border-white/[0.09] rounded-xl px-4 py-2.5 text-sm text-kaizen-text outline-none focus:border-kaizen-violet/60 transition-colors duration-300"
          />
        </div>
        <div>
          <label className="text-xs text-kaizen-dim tracking-wide">Password</label>
          <input
            type="password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            data-testid="login-password-input"
            className="mt-1.5 w-full bg-white/[0.04] border border-white/[0.09] rounded-xl px-4 py-2.5 text-sm text-kaizen-text outline-none focus:border-kaizen-violet/60 transition-colors duration-300"
          />
        </div>
        {error && (
          <p className="text-xs text-ready-rose" data-testid="login-error">
            {error}
          </p>
        )}
        <button
          type="submit"
          disabled={loading}
          data-testid="login-submit-button"
          className="glow-cta w-full py-3 rounded-full bg-kaizen-violet text-[#140A24] font-semibold text-sm hover:scale-[1.02] active:scale-[0.98] transition-transform duration-300 disabled:opacity-60"
        >
          {loading ? "Signing in…" : "Log in"}
        </button>
      </form>

      <p className="mt-6 text-sm text-kaizen-dim">
        New to Kaizen?{" "}
        <Link to="/signup" data-testid="link-to-signup" className="text-kaizen-violetSoft hover:underline">
          Meet Nova
        </Link>
      </p>
    </div>
  );
}
